export default "__VITE_ASSET__CG_zctv9__"